const valueExistsInSelected = ({ state, props, path }) => {
  const selectedOptions = state.get(`selectr.${props.namespace}.selected`)
  const { value } = props
  const index = selectedOptions.reduce((acc, option, index) => {
    if (value.toLowerCase() === option.label.toLowerCase()) {
      acc = index
    }
    return acc
  }, null)
  if (index === null) {
    return path.false()
  } else {
    return path.true({ index })
  }
}

valueExistsInSelected.displayName = 'valueExistsInSelected'
export default valueExistsInSelected
